import { render, staticRenderFns } from "./ViewSelectedTrade.vue?vue&type=template&id=0271b7aa&scoped=true&"
import script from "./ViewSelectedTrade.vue?vue&type=script&lang=js&"
export * from "./ViewSelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewSelectedTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ViewSelectedTrade.vue?vue&type=style&index=2&id=0271b7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271b7aa",
  null
  
)

export default component.exports